function getSelectedDateCountLabel(eventResource, count) {
    const label = count === 1
        ? eventResource.dateUnitLabelSingular
        : eventResource.dateUnitLabelPlural;

    return `${count} ${label.toLowerCase()} selected`;
}

export {getSelectedDateCountLabel};
